import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api, ApiError } from '../services/api';

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (newPassword !== confirm) { setError('Passwords do not match'); return; }
    if (!token) { setError('Missing reset token'); return; }
    setError(null);
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, newPassword });
      setDone(true);
      setTimeout(() => nav('/login'), 2000);
    } catch (e) {
      if (e instanceof ApiError) {
        if (e.code === 'invalid_token') setError('Link is invalid or expired. Request a new one.');
        else setError(e.message || 'Reset failed');
      } else setError('Reset failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-md border border-slate-200 p-8">
        <h1 className="text-xl font-bold text-brand-navy mb-2">Set your password</h1>
        <p className="text-slate-500 text-sm mb-6">
          At least 8 characters.
        </p>

        {done ? (
          <div className="bg-emerald-50 border border-emerald-200 rounded-md p-3 text-sm text-emerald-800">
            Password set. Redirecting to sign in…
          </div>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <input
              type="password" required placeholder="New password"
              value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
              className="w-full border border-slate-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-navy/40"
            />
            <input
              type="password" required placeholder="Confirm new password"
              value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full border border-slate-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-brand-navy/40"
            />
            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-md px-3 py-2">{error}</div>
            )}
            <button
              type="submit" disabled={busy}
              className="w-full bg-brand-navy text-white font-semibold rounded-md py-2 hover:bg-brand-navy/90 disabled:opacity-50"
            >
              {busy ? 'Setting…' : 'Set password'}
            </button>
          </form>
        )}

        <div className="mt-4 text-center text-sm">
          <Link to="/login" className="text-brand-navy hover:underline">Back to sign in</Link>
        </div>
      </div>
    </main>
  );
}
